import { admins, teams } from '@/firebase-firestore'
export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    user: null,
    access: null,
    adminUsers: admins.slice(),
    teamUsers: teams.slice()
  },
  mutations: {
    setUsers (state: any, users:any) {
      state.users = users
    },
    setUser (state:any, user:any) {
      state.user = user
    }
  },
  getters: {
    hasUsers: (state:any): boolean => {
      return Array.isArray(state.users)
    },
    isLogged: (state:any): boolean => {
      return typeof state.user?.email === 'string' && state.user.email.length > 0
    },
    isAdmin: (state:any): boolean => {
      return state.adminUsers.includes(state.user?.email)
    },
    userAccess: (state:any, getters:any): string | null => {
      return getters.isAdmin ? 'admin' : getters.isLogged ? 'team' : null
    }
  }
}
